module.exports = __webpack_public_path__ + "img/arrow-counterclockwise.435e5819.svg";